import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
import { getDeviceStatusColor, getDeviceStatusDescription } from 'modules/HealthCheck/helpers';
import spacing from 'theme/spacing';
const DeviceStatusItem = styled.div `
  display: flex;
  justify-content: space-between;
  width: 100%;
  font-size: 18px;
`;
const DeviceStatusItemLeft = styled.div `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;
const DeviceStatusItemDescription = styled.span `
  text-align: left;
  font-size: 18px;
  font-weight: 300;
`;
const DeviceStatusItemRight = styled.div `
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  font-size: 18px;
  font-weight: 300;
`;
const dot = css `
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
`;
export const StatusDot = styled.div `
  ${dot};
  margin-right: ${spacing.spacing4};

  background-color: ${({ $status }) => getDeviceStatusColor($status)};
`;
export const DeviceStatusListItem = ({ statusDescription, description, deviceStatus, }) => (_jsxs(DeviceStatusItem, { children: [_jsxs(DeviceStatusItemLeft, { children: [description, _jsx(DeviceStatusItemDescription, { children: statusDescription })] }), _jsx(DeviceStatusItemRight, { children: _jsxs("div", { children: [_jsx(StatusDot, { "$status": deviceStatus }), getDeviceStatusDescription(deviceStatus)] }) })] }));
